import type { ReactNode, CSSProperties } from "react";
import { cn } from "@/utils/cn";

interface Props {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function MaxWidthWrapper({ children, className, style }: Props) {
  return (
    <div className={cn("mx-auto max-w-7xl px-4 md:px-8", className)} style={style}>
      {children}
    </div>
  );
}
